import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import CSF_bar_colors from 'data/CSF_bar_colors';

import { Button, Modal } from 'antd';

export const SCFPlot = ({ data }) => {
  const [showInfo, setInfoModal] = useState(false);

  const InfoModal = (
    <Modal
      title='Sample Color Fidelity'
      visible={showInfo}
      onCancel={() => setInfoModal(false)}
      footer={[
        <Button key='close' onClick={() => setInfoModal(false)}>
          Close
        </Button>,
      ]}
    >
      Sample Color Fidelity characterizes the magnitude of color difference
      between the test source and reference illuminant for each color evaluation
      sample. Values closer to 100 indicate greater similarity to the reference.
      The colors of the bars are for visual orientation only.
    </Modal>
  );

  let x = [];
  let x_tickvals = [];
  let y = [];
  let y_rounded = [];
  data.map((value) => y.push(value / 100));
  y.unshift(0.0); // Simple hack - add a dummy initial value to render the graph properly
  for (let i = 0; i < 100; i++) {
    y_rounded[i] = `${Math.round(y[i] * 100)}`;
  }
  for (let i = 0; i < 100; i++) {
    x.push(i);
  }
  for (let i = 1; i <= 97; i = i + 3) {
    x_tickvals.push(i);
  }

  return (
    <>
      <Plot
        useResizeHandler={true}
        // style={{ width: "100%" }}
        title={null}
        data={[
          {
            name: '',
            type: 'bar',
            x: x,
            y: y,
            marker: {
              color: CSF_bar_colors.colors,
            },
            textfont: {
              size: 14,
            },
            text: y_rounded,
            textposition: 'none',
            hovertemplate: `R<sub><i>f</i>,CES%{x}</sub>: %{text}`,
          },
        ]}
        layout={{
          width: 1050,
          height: 300,
          margin: {
            l: 60,
            r: 6,
            b: 45,
            t: 10,
            pad: 0,
          },
          xaxis: {
            range: [0.5, 99.5],
            tickmode: 'array',
            tickvals: x_tickvals,
            title: {
              text: 'Color Evaluation Sample',
              font: {
                size: 16,
              },
            },
            fixedrange: true,
            mirror: 'ticks',
            linewidth: 2,
            linecolor: 'black',
            // ticklen: 6,
            // tickwidth: 2,
          },
          yaxis: {
            showline: true,
            range: [0, 1.0],
            tickmode: 'array',
            tickvals: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
            ticktext: [
              '0',
              '10',
              '20',
              '30',
              '40',
              '50',
              '60',
              '70',
              '80',
              '90',
              '100',
            ],
            title: {
              text: 'Sample Color Fidelity (<i>R</i><sub>f,ces<i>i</i></sub>)</b>',
              font: {
                size: 16,
              },
            },
            //tickformat: ""
            fixedrange: true,
            mirror: 'ticks',
            linewidth: 2,
            linecolor: 'black',
          },
          bargap: 0,
        }}
        config={{
          displaylogo: false,
          modeBarButtons: [
            [
              'toImage',
              {
                name: 'Info',
                icon: '',
                click: () => setInfoModal(true),
              },
            ],
          ],
          responsive: true,
          toImageButtonOptions: {
            format: 'png', // one of png, svg, jpeg, webp
            filename: 'Colar Sample Fidelity',
            height: 300,
            width: 1050,
            scale: 1.5, // Multiply title/legend/axis/canvas sizes by this factor
          },
        }}
      />
      {InfoModal}
    </>
  );
};

SCFPlot.propTypes = {
  data: PropTypes.array,
};
